import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import AuthProvider from "./store/AuthContext";
import { ToadsProvider } from "./store/ToadsContext";

ReactDOM.render(
  <ToadsProvider>
    <AuthProvider>
     
        <App />
     
    </AuthProvider>
  </ToadsProvider>,
  document.getElementById("root")
);
